import styled from 'styled-components';

export const ModalWebWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalContainer = styled.div`
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  width: 92vw;
  padding: 12px 0;
`;

export const TitleCont = styled.div`
  font-size: 1.6rem;
  font-weight: 900;
  font-family: 'Lato';
  color: #000000;
  border-bottom: 1px solid #e5e5e5;
  padding: 0 12px 12px;
  text-align: center;
`

export const SubtitleCont = styled.div`
  font-size: 1.6rem;
  font-weight: 500;
  font-family: 'Lato';
  color: #000000;
  padding: 12px;
`

export const ButtonCont = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 10vw;

  & .positiveActionBtn {
    font-size: 20px;
    font-weight: 700;
    font-family: 'Lato';
    color: #007bff;
    width: 20vw;
  }

  & .negativeActionBtn {
    color: #AD9999;
    width: 20vw;
    font-size: 20px;
    font-weight: 700;
    font-family: 'Lato';
  }
`